import { atom } from "jotai";
import { SearchFilter } from "./SearchFilter";

export const treeFilterAtom = atom<SearchFilter[]>([]);
